export const StreamOperation = {
    Insert: 'insert',
    Delete: 'delete',
    Replace: 'replace',
    Update: 'update',
    Invalidate: 'invalidate',
};
